/* eslint-disable implicit-arrow-linebreak */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import { IPremiumPayoutConfig } from 'src/interfaces';

import BenefitsService from 'src/services/benefits.service';

export const usePostBenefitPremiumPayout = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation((data: IPremiumPayoutConfig) => BenefitsService.postBenefitPremiumPayout(data), {
    onSuccess: () => {
      AlertAdapter('Premium and payout added successfully', 'success');
      queryClient.invalidateQueries({ queryKey: ['benefits/premium'] });
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });
  return mutation;
};
